var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { role: "main" } }, [
    _c("div", { staticClass: "row" }, [
      _c("h1", { staticClass: "col-12" }, [
        _vm._v(_vm._s(_vm.$t("Menu.AidApplications")))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-md-6" }, [
        _vm.showApplyContent
          ? _c("div", { staticClass: "mb-5" }, [
              _c("h2", { staticClass: "mb-4" }, [
                _vm._v(_vm._s(_vm.$t("NewApplication")))
              ]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$t("NewApplicationInstructions")))]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row form-group" },
                [
                  _c("single-select-accessible", {
                    staticClass: "col-12 col-sm-10",
                    attrs: {
                      title: "AidTypePlaceholder",
                      options: _vm.aidTypeOptions,
                      placeholder: _vm.$t("AidTypePlaceholder"),
                      dropdownId: "aidtypeoptions",
                      srLabel: true,
                      savable: false
                    },
                    model: {
                      value: _vm.selectedAidType,
                      callback: function($$v) {
                        _vm.selectedAidType = $$v
                      },
                      expression: "selectedAidType"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.showBDropdownForNewApplication
                ? _c(
                    "div",
                    { staticClass: "row form-group" },
                    [
                      _c("single-select-accessible", {
                        staticClass: "col-12 col-sm-10",
                        attrs: {
                          title: "AidApplication.BasicInfo.Investment.Type",
                          options: _vm.aidTypeOptionsForB,
                          placeholder: _vm.$t("Selection.Choose"),
                          dropdownId: "aidtypeboptions",
                          srLabel: true,
                          savable: false
                        },
                        model: {
                          value: _vm.selectedBType,
                          callback: function($$v) {
                            _vm.selectedBType = $$v
                          },
                          expression: "selectedBType"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-2" }, [
                  _c(
                    "button",
                    {
                      class: [
                        _vm.isNewApplicationBtnDisabled
                          ? "btn btn-default"
                          : "btn btn-secondary"
                      ],
                      attrs: {
                        disabled: _vm.isNewApplicationBtnDisabled,
                        "aria-disabled": _vm.isNewApplicationBtnDisabled
                      },
                      on: {
                        click: function($event) {
                          return _vm.startNewAidApplication()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Btn_Start")))]
                  )
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showExtensionApplyContent
          ? _c("div", { staticClass: "mb-5" }, [
              _c("h2", { staticClass: "mb-4" }, [
                _vm._v(_vm._s(_vm.$t("ExtensionApplication")))
              ]),
              _vm._v(" "),
              !_vm.extensionOptionsRetrieved
                ? _c("p", [_vm._v(_vm._s(_vm.$t("Loading")) + "...")])
                : _vm._e(),
              _vm._v(" "),
              _vm.extensionOptionsRetrieved && _vm.aidtargetOptions.length == 0
                ? _c("p", [_vm._v(_vm._s(_vm.$t("NoExtensionOptions")))])
                : _c("div", [
                    _c("p", [
                      _vm._v(_vm._s(_vm.$t("ExtensionApplicationInstructions")))
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row form-group" },
                      [
                        _c("single-select-accessible", {
                          staticClass: "col-12 col-sm-10",
                          attrs: {
                            title: "ExtensionPlaceholder",
                            options: _vm.aidtargetOptions,
                            placeholder: _vm.$t("ExtensionPlaceholder"),
                            dropdownId: "aidtargetoptions",
                            srLabel: true,
                            doNotUseResources: true,
                            savable: false,
                            disabled:
                              !_vm.extensionOptionsRetrieved ||
                              _vm.aidtargetOptions.length == 0
                          },
                          model: {
                            value: _vm.selectedAidTargetId,
                            callback: function($$v) {
                              _vm.selectedAidTargetId = $$v
                            },
                            expression: "selectedAidTargetId"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.showBDropDownForExtension
                      ? _c(
                          "div",
                          { staticClass: "row form-group" },
                          [
                            _c("single-select-accessible", {
                              staticClass: "col-12 col-sm-10",
                              attrs: {
                                title:
                                  "AidApplication.BasicInfo.Investment.Type",
                                options: _vm.aidTypeOptionsForBExtension,
                                placeholder: _vm.$t("Selection.Choose"),
                                dropdownId: "extension_aidtypeboptions",
                                srLabel: true,
                                savable: false,
                                disabled: _vm.bTypeSetByEarlierApplication
                              },
                              model: {
                                value: _vm.selectedBTypeForExtension,
                                callback: function($$v) {
                                  _vm.selectedBTypeForExtension = $$v
                                },
                                expression: "selectedBTypeForExtension"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-2" }, [
                        _c(
                          "button",
                          {
                            class: [
                              _vm.isNewExtensionApplicationBtnDisabled
                                ? "btn btn-default"
                                : "btn btn-secondary"
                            ],
                            attrs: {
                              disabled:
                                _vm.isNewExtensionApplicationBtnDisabled,
                              "aria-disabled":
                                _vm.isNewExtensionApplicationBtnDisabled
                            },
                            on: {
                              click: function($event) {
                                return _vm.startNewExtensionApplication()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("Btn_Start")))]
                        )
                      ])
                    ])
                  ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-sm-10 col-md-6 mb-3" }, [
        _c("h2", { staticClass: "mb-4", attrs: { id: "aidTypeTitle" } }, [
          _vm._v(_vm._s(_vm.$t("AidTypeTitle")))
        ]),
        _vm._v(" "),
        _c("div", { domProps: { innerHTML: _vm._s(_vm.$t("AidTypeContent")) } })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }